import React from 'react';
import type { useGetEventCTAButtonsDataLazyQuery } from '../CtaButtons/CtaButtons.graphql.generated';
import { useEventInfo } from '@shared/utils/eventInfo';
import { useDisclosure } from '@withjoy/joykit';
import { useMediaQuery } from '@withjoy/joykit/utils';
import { GuestGuideContent } from './GuestGuideContent';
import { GuestGuideTelemetryProvider } from './GuestGuideTelemetry';
import { GuestGuideTrigger } from './GuestGuideTrigger';
import { DesktopWrapper, MobileWrapper } from './GuestGuideWrappers';
import { ReminderModalProvider } from './ReminderModalContext';
import { ReminderModalWrapper } from './ReminderModalWrapper';
import type { BreakpointAliasKey } from '@withjoy/joykit/theme';
import { getCountDownDate } from './getCountDownDate';

const ALOHA_BREAKPOINT: BreakpointAliasKey = 'sm4';

const GuestGuideModal: React.FC<{ sessionData: ReturnType<typeof useGetEventCTAButtonsDataLazyQuery>[1]['data'] | undefined }> = ({ sessionData }) => {
  const { eventHandle, eventInfo } = useEventInfo();
  const rsvpAttendanceStatus = sessionData?.eventByName?.activeSession?.eventCTA?.rsvpAttendanceStatus;

  const isDesktop = useMediaQuery(theme => theme.mediaQueries.up({ breakpointAlias: ALOHA_BREAKPOINT }));
  const { isOpen: isGuestGuideOpen, onOpen: onGuestGuideOpen, onClose: onGuestGuideClose } = useDisclosure();

  const countDownDate = getCountDownDate(eventInfo?.settings.hideEventCountdown, eventInfo?.finalizedDate?.milliseconds);

  const guestGuideContent = (
    <GuestGuideContent
      countDownDate={countDownDate}
      sessionData={sessionData}
    />
  );

  return (
    <GuestGuideTelemetryProvider>
      <ReminderModalProvider>
        <>
          {isDesktop ? (
            <DesktopWrapper
              trigger={
                <GuestGuideTrigger
                  rsvpAttendanceStatus={rsvpAttendanceStatus}
                  eventHandle={eventHandle}
                />
              }
              isOpen={isGuestGuideOpen}
              onOpen={onGuestGuideOpen}
              onClose={onGuestGuideClose}
            >
              {guestGuideContent}
            </DesktopWrapper>
          ) : (
            <MobileWrapper
              trigger={
                <GuestGuideTrigger
                  rsvpAttendanceStatus={rsvpAttendanceStatus}
                  eventHandle={eventHandle}
                />
              }
              isOpen={isGuestGuideOpen}
              onOpen={onGuestGuideOpen}
              onClose={onGuestGuideClose}
            >
              {guestGuideContent}
            </MobileWrapper>
          )}
        </>
        <ReminderModalWrapper />
      </ReminderModalProvider>
    </GuestGuideTelemetryProvider>
  );
};

export default GuestGuideModal;
